import { render, staticRenderFns } from "./ChinaStockTrade.vue?vue&type=template&id=3b1407ad&scoped=true"
import script from "./ChinaStockTrade.vue?vue&type=script&lang=js"
export * from "./ChinaStockTrade.vue?vue&type=script&lang=js"
import style0 from "./ChinaStockTrade.vue?vue&type=style&index=0&id=3b1407ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1407ad",
  null
  
)

export default component.exports